<template>
    <v-card elevation="0" class="card-shadow">
        <v-row class="pa-3">
            <v-col cols="9">
                <div class="title page-subheader px-2" style="text-align: left;">
                    <span v-if="text" v-html="text"></span>
                    <slot name="text"></slot>
                </div>
            </v-col>
            <v-col cols="3">
                <v-img
                    :src="icon"
                    :width="iconWidth ? iconWidth : '45'"
                    v-if="icon"
                    style="margin: 0 auto;"
                ></v-img>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    name: "InfoBox",
    props: ["text", "icon", "iconWidth"],
    data() {
        return {};
    },
};
</script>
